import React from 'react'
import styles from './LargeCta.module.css'

export default function LargeCta() {
    return (
        <section id='large-cta' className={styles.largeCta}>
            <div className={styles.largeCtaBox}>
                <figure>
                    <img
                        src={`/pages/business/foodstadium/large-cta.svg`}
                        alt='飲食業界で働く方に支持される転職サービスNo.1'
                    />
                </figure>
                <a href='#form'>掲載について問い合わせてみる</a>
                <p>
                    ＊2023年3月期_ブランドのイメージ調査(調査1~3)
                    ・調査機関:日本マーケティングリサーチ機構：調査期間:2023年1月5日~2023年3月14日・n
                    数:127(※調査 1)、147(※調査 2)、591(※調査 3)/調査方法:Web
                    アンケート・調査対象者:https://jmro.co.jp/r01414/・備考:本調査は個人のブランドに対するイメージを元にアンケートを実施し集計しております。/
                    本ブランドの利用有無は聴取しておりません。/効果効能等や優位性を保証するものではございません。/競合
                    2 位との差は 5%以上。
                </p>
            </div>
        </section>
    )
}
